<h4>Role Based Permissions</h4>
<div class="mat-menu__item">
  <strong>Owner</strong><br />
  <small>Full control over global changes.</small>
</div>
<div class="mat-menu__item">
  <strong>Editor</strong><br />
  <small>Add, delete and archive files and folders</small>
</div>
<div class="mat-menu__item">
  <strong>Contributor</strong><br />
  <small>Add files and folders</small>
</div>
<div class="mat-menu__item">
  <strong>Read</strong><br />
  <small>View and download documents</small>
</div>
<div class="mat-menu__item">
  <strong>View</strong><br />
  <small>View documents</small>
</div>
<ng-container *ngIf="isUserAdminRole()">
  <div class="mat-menu__item">
    <strong>Admin</strong><br />
    <small>View and modify accounts, account users, and scanners</small>
  </div>
  <div class="mat-menu__item">
    <strong>SuperAdmin</strong><br />
    <small>Full admin access plus control admin users</small>
  </div>
</ng-container>
